// Mirrors OrderTimeline.js's visual language (black dot, gray connector) --
// same design system, different data source (workflow_step_executions
// instead of commerce_events).
const DOT = { COMPLETED: 'bg-black', RUNNING: 'bg-gray-400', FAILED: 'bg-red-600' };
const LINE = 'bg-gray-200';

const STEP_LABEL = { action: 'Action', wait: 'Wait', approval: 'Approval', branch: 'Branch', complete: 'Complete' };

function formatWhen(value) {
	if (!value) return '';
	const date = new Date(value);
	const time = date.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' });
	const day = date.toLocaleDateString([], { month: 'short', day: 'numeric' });
	return { time, day };
}

export default function WorkflowRunTimeline({ steps }) {
	if (!steps?.length) {
		return <p className='text-sm text-gray-400'>No steps have run yet.</p>;
	}

	return (
		<ul>
			{steps.map((step, i) => {
				const isLast = i === steps.length - 1;
				const { time, day } = formatWhen(step.started_at);
				return (
					<li key={`${step.step_id}-${step.attempt}-${i}`} className='flex gap-3'>
						<div className='flex flex-col items-center'>
							<div className={`w-2.5 h-2.5 rounded-full shrink-0 mt-1 ${DOT[step.status] || 'bg-gray-300'}`} />
							{!isLast && <div className={`w-0.5 flex-1 my-1 ${LINE}`} />}
						</div>
						<div className='pb-4'>
							<div className='flex items-baseline gap-2'>
								<span className='text-sm font-medium'>
									{STEP_LABEL[step.step_type] || step.step_type} &middot; {step.step_id}
								</span>
								{step.attempt > 1 && <span className='text-xs text-gray-400'>attempt {step.attempt}</span>}
								<span className='text-xs text-gray-400'>
									{day} {time}
								</span>
							</div>
							{step.status === 'FAILED' && step.error_message && <p className='text-xs text-red-600 mt-0.5'>{step.error_message}</p>}
						</div>
					</li>
				);
			})}
		</ul>
	);
}
